export const API_URL = "http://api.washeria.ro";
export const TOKEN_NAME = "washeria_at";